"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _isFunction2 = _interopRequireDefault(require("lodash/isFunction"));

var _recompose = require("recompose");

/**
 * Counts down to zero in seconds starting from the "timerSeconds" input prop.
 *
 * Input:
 *   timerSeconds (number): Duration of timer in seconds (required)
 *   onCountdownEnd (function): Timer completed callback
 *
 * Output:
 *   startCountdown (function): Initiates countdown
 *   remainingSeconds (number): Number of seconds left in timer
 */
var _default = (0, _recompose.compose)((0, _recompose.withState)('timerInterval', 'setTimerInterval', null), (0, _recompose.withStateHandlers)(function (_ref) {
  var timerSeconds = _ref.timerSeconds;
  return {
    remainingSeconds: timerSeconds
  };
}, {
  tick: function tick(_ref2, _ref3) {
    var remainingSeconds = _ref2.remainingSeconds;
    var onCountdownEnd = _ref3.onCountdownEnd,
        timerInterval = _ref3.timerInterval;
    return function () {
      if (parseInt(remainingSeconds) - 1 <= 0 && timerInterval) {
        if ((0, _isFunction2["default"])(onCountdownEnd)) {
          onCountdownEnd();
        }

        clearInterval(timerInterval);
      }

      return {
        remainingSeconds: remainingSeconds - 1
      };
    };
  }
}), (0, _recompose.withHandlers)({
  startCountdown: function startCountdown(_ref4) {
    var tick = _ref4.tick,
        setTimerInterval = _ref4.setTimerInterval;
    return function () {
      return setTimerInterval(setInterval(tick, 1000));
    };
  }
}), (0, _recompose.lifecycle)({
  componentWillUnmount: function componentWillUnmount() {
    clearInterval(this.props.timerInterval);
  }
}));

exports["default"] = _default;